import { render, staticRenderFns } from "./SimpleCategorization.vue?vue&type=template&id=1a71dd8f&"
import script from "./SimpleCategorization.vue?vue&type=script&lang=ts&"
export * from "./SimpleCategorization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports